import React, { PureComponent } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, DialogContainer, TextField,SelectionControl } from 'react-md';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { browserHistory } from 'react-router';
import ApiRequestService from '../component/ApiRequestService';
import restoreQuestionBankHandler from '../component/ArchiveRestoreAPI';
import LoadingSpinner from '../component/LoadingSpinner';
import Properties from '../component/Properties';
import SearchBar from '../component/SearchBar';
import TableRow from '../component/TableRow';
import '../css/mediaCss.css';
import styles from '../css/styles.css.js';
import topicStyles from '../css/topicStyles.css.js';
import UserAccessDetails from '../lib/UserAccessDetails';
import { AppSetting, AppProperties,ADMIN_USER_ROLE } from '../common/function';
import ReactTooltip from 'react-tooltip';




let topic = {
  topic_name: '',
  topic_id: '',
  subject_id:''
};
export default class Topics extends PureComponent {
  userAccessDetails = new UserAccessDetails();
  AppSetting = AppSetting();
  appProperties = AppProperties();
  baseFolder = this.appProperties.baseFolder;
  
  constructor(props) {
    super(props);
    this.state = {
      topics: [],
      temp_topic: topic,
      temp_id: '',
      addMode: true,
      visible: false,
      subject_id: this.props.location.query.subject_id,
      subject_name: this.props.location.query.subject_name,
      loading: true,
      synloading:true,
      redirectLoading:false,
      readOnly:this.props.location.query.archive_mode === 'true',
      archive_id:parseInt(this.props.location.query.archive_id,10),
      archive_mode:this.props.location.query.archive_mode,
      instructor_name: window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`),
      userprofilerole : parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10),
      instSubjects:[],
      currSubject:false,
      countOfTCSQ:[],
      topicSync:[],
      syncAccess:false,
      AllTopForSuperadmin:false,
      _userAccessDetails: JSON.parse(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_userAccessDetails`))
    };

    this.deleteTopic = this.deleteTopic.bind(this);
    this.addTopic = this.addTopic.bind(this);
    this.changeTopicName = this.changeTopicName.bind(this);
    this.isEnterPressed = this.isEnterPressed.bind(this);        
    this.updateTopic = this.updateTopic.bind(this);
    this.updateTopicResponseHandler = this.updateTopicResponseHandler.bind(
      this
    );
    this.onEnableSync = this.onEnableSync.bind(this);  
    this.onDisableSync = this.onDisableSync.bind(this);
    this.onHandleRedirect = this.onHandleRedirect.bind(this)
    
  }

  addBreadCrumbs = () => {
    console.debug('Topics AddBreadCrumbs');
    this.props.replaceBreadCrumb([
      {
        name: 'All Subjects',
        type: '',
        onclickPath: 'subjects?'+
        '&archive_mode='+
        this.state.archive_mode+
        '&archive_id='+
        this.state.archive_id
      },
      {
        name: this.state.subject_name,
        type: 'Subjects',
        onclickPath:
          'topics?subject_id=' +
          this.state.subject_id +
          '&subject_name=' +
          this.state.subject_name+
          '&archive_mode='+
          this.state.archive_mode+
          '&archive_id='+
          this.state.archive_id
      }
    ]);
  };

  componentWillUnmount() {
    this.removeBreadCrumbs();
  }

  onHandleRedirect = (topic) => {

    let subjectRedirect = parseInt(this.state.subject_id)
    if ((this.state.instSubjects && !(this.state.instSubjects[subjectRedirect] === true))|| this.appProperties.enableLTI) {
  
      let navigatePage =
        `category?topic_id=${topic.topic_id}`+
        `&subject_id=${this.state.subject_id}`+
        `&subject_name=${this.state.subject_name}`+
        `&topic_name=${topic.topic_name}`+
        `&archive_mode=${this.state.archive_mode}`+
        `&archive_id=${this.state.archive_id}`
        
      this.setState({
        loading: true,
        redirectLoading:true
      });
      //fetch  source redirect url 

     let  payload = {
        subject_id: subjectRedirect
      }
      ApiRequestService({
        method: 'post',
        url: '/sourceUnivUrl',
        data: payload
      })
      .then(res => {
        if (res.data.message !== null && res.data.message !== '') {
          NotificationManager.error(res.data.message, 'ERROR', 3000);
          this.setState({
            loading: false,
            redirectLoading:true
          });
        }
        
        
        if(res.data && res.data.status === 0){
          let response = res.data.data
          let soucreBase= response.REACT_APP_URL
          let sourceURL = soucreBase + navigatePage
          //navigate source Page
          window.open(sourceURL, '_blank');

           //navigate current Page
           browserHistory.push(this.appProperties.baseFolder + navigatePage);
          this.setState({
            loading: false,
            redirectLoading:true
          });
        }

        
      }).catch((err)=> {
        console.debug("error from source univ url",err)

        this.setState({
          loading: false,
          redirectLoading:false
        });
      })

    }

  }
  getSyncSwitchAccess = () => {

    if ( this.state.userprofilerole === ADMIN_USER_ROLE){
        ApiRequestService({
          method:'post',
          url:'/syncSwitch'
        }).then(res => {
          let syncAccess = res.data.data
 
          if (syncAccess) {

            this.setState({
              syncAccess:true
            });
          }
        }).catch (err => {
          this.setState({
            synloading:false
          })
        })
  
    }
  }




  removeBreadCrumbs = () => {
      this.props.replaceBreadCrumb([
      ]);     
    

  };

  
  componentWillUpdate() {
   
    this.addBreadCrumbs();
  }

  componentDidUpdate(){
    this._refresh();
 }
  _refresh(){
    // refresh if subject id is changed in url
    
    let paramsSubjectId = this.props.location.query.subject_id
    if (this.state.subject_id !== paramsSubjectId ) {
      this.state.subject_id = this.props.location.query.subject_id
      this.state.subject_name = this.props.location.query.subject_name
      this.getCountOfTCSQ();
      this.getAllTopics();
    }

  }
  superAdminSyncTopValidation ()  {
    this.setState({
      AllTopForSuperadmin: !this.state.AllTopForSuperadmin
    });
  }
  getAllTopicSync = () => {

    //If Super Admin
    if ( this.state.userprofilerole === 2 && (this.state.syncAccess)){
        var sub_id = parseInt(this.state.subject_id, 10);
        let payload = {
            subject_id: sub_id
        };
    
    
        ApiRequestService({
          method:'post',
          url:'/getAllTopicSync',
          data:payload
        }).then(res => {
          let syndata = res.data.data.topic_names 
    
          let tempAllTopics = this.state.topics
    
          for(let top of tempAllTopics) {
            for(let syn of syndata) {
              if (top.subject_id == syn.subject_id && top.topic_id == syn.topic_id) {
                top.enable_sync = syn.enable_sync
                top.some_sync = syn.some_sync
                top.sync_status = syn.sync_status
              }
            }
          }
    
          this.setState({
            topics: tempAllTopics,
            synloading: false ,
            topicSync: syndata
          });
        }).catch (err => {
          this.setState({
            synloading:false
          })
        })
  
    }
    

  }
  getAllTopics = () =>{
    this.setState({ loading: true });
     // this.getInstSubjectData();
      
  
  //componentWillMount() {
    // this.getInstSubjectData();
      console.debug("componentwillmount");
    
    var sub_id = parseInt(this.state.subject_id, 10);
    let payload = {
        // subject_id: this.state.subject_id
        subject_id: sub_id
      };
    let allUnivSubjects = this.userAccessDetails.getAllSubjects(false);
    let instSubjectPromise = this.userAccessDetails.getSubjectsByInstructor();
    instSubjectPromise.then(subjectsByIns => {
      let currSubject = false
     if(subjectsByIns !== null){
        if(subjectsByIns[sub_id]===true){
          currSubject= true
        }
     }
      //let topicsList =res.data.data.topic_names;      
    

    if(this.state.archive_mode === 'true'){
      payload['archive_id'] = this.state.archive_id;
      payload['archive_mode'] = true;
    }
    ApiRequestService({
      method: 'post',
      url: '/getAllTopics',
      data: payload
    }).then(res => {
      console.debug(res.data.data.topic_names);
      if (res.data.data.topic_names != null) {
          this.setState({
            topics: res.data.data.topic_names,
            instSubjects :subjectsByIns,
            currSubject:currSubject,
            loading: false 
          });
          this.getAllTopicSync();
        }else{
          this.setState({
            instSubjects :subjectsByIns,
            currSubject:currSubject,
            loading: false 
          });
        }
        })
      
    }).catch(err=>{
      this.setState({ 
        loading: false 
      });
      console.error('ERROR : ', err);
      NotificationManager.error(err, 'ERROR', 3000);
      this.hide();
    })
    console.debug("componentwillmount");
    
  }
  componentWillMount() {
    this.getCountOfTCSQ();
    this.getAllTopics();
    this.getSyncSwitchAccess()
  }

  getCountOfTCSQ = () => {
    console.debug('getCountOfTCSQ :');
    var sub_id = parseInt(this.state.subject_id, 10);
    const payload = {
      subject_id : sub_id,
      topic_id : 0 ,
      category_id : 0,
      subcategory_id : 0 
    }

    ApiRequestService({
      method: 'post',
      url: '/getCountOfTCSQ',
      data: payload
    }).then(res => {
      if(res.data.data !== undefined && res.data.data !== null && res.data.data.CountOfTCSQ !== undefined && res.data.data.CountOfTCSQ !== null){
        console.debug(res);
        console.debug('getCountOfTCSQ State: ');
        this.setState({
          countOfTCSQ : res.data.data.CountOfTCSQ
        });
        this.hide();
      }
    });
  }
  

  addTopic() {
    /*141 Subject, Topic, Cat, Sub Cat Names should not allow empty or empty space*/
    
    this.setState({ loading: true });

    if (
      this.state.temp_topic.topic_name === null ||
      this.state.temp_topic.topic_name.trim() === ''
    ) {
      alert('Please enter a valid "Topic name"');
      return;
    }
    console.debug('Add topic :' + this.state.temp_topic.topic_name);
    var sub_id = parseInt(this.state.subject_id, 10);
    const payload = {
      topic_name: this.state.temp_topic.topic_name.trim(),
      subject_id: sub_id
    };
    ApiRequestService({
      method: 'post',
      url: '/addTopic',
      data: payload
    }).then(res => {
      if (res.data.message !== null && res.data.message !== '') {
        // Bug id #143 fixed
        this.setState({ loading: false });
        this.hide();
        NotificationManager.error(res.data.message, 'ERROR', 3000);
        return;
      }
      console.debug('After return');

      if (res.data.data != null) {
        console.debug("topics ",this.state.instSubjects,"   ",res.data.data.topic_id)
        this.state.topics.push({
          topic_name: res.data.data.topic_name,
          topic_id: res.data.data.topic_id,
          subject_id:sub_id,
          enable_sync: res.data.data.enable_sync,
          sync_status:res.data.data.sync_status, 
          sync_validation:res.data.data.sync_validation,  
        });
        this.state.countOfTCSQ.push({
          number_of_categories: 0,
          number_of_subcategories:0,
          number_of_questions:0
        })
        this.setState({
          topics: this.state.topics,
          loading: false,
          synloading:false,
          countOfTCSQ:this.state.countOfTCSQ
        });
        this.hide();
      }
      
    }).catch(err=>{
      console.error('ERROR : ', err);
      NotificationManager.error(err, 'ERROR', 3000);
      this.setState({ loading: false });
      this.hide();
    });    
    
  }

  onEnableSync = (index)=>{
    this.setState({loading:true});
    const payload = {
      topic_id:this.state.topics[index].topic_id,
      subject_id: this.state.topics[index].subject_id,
      enable_sync:true
    };
    // LTI sync disable
    if( this.appProperties.enableLTI ) {
      this.setState({
        loading: false
      });
      return
    }
    
     //check empty topic
     let subCountOfTCSQ = this.state.countOfTCSQ[index]
     if (subCountOfTCSQ.number_of_categories == 0) {
       NotificationManager.error(
         'Error',
         'Unable To Sync Empty Topic. Please Add Category And Try Again',
         5000
       );
 
       this.setState({
         loading: false
       });
       return
     }
    ApiRequestService({
      method: 'post',
      url: '/sync/enableSyncTopic',
      data: payload
    })
      .then(res => {
        if (res.data.message !== null && res.data.message !== '') {
          NotificationManager.error(res.data.message, 'ERROR', 3000);
          this.setState({
            loading: false
          });
        }
        
        
        if(res.data && res.data.status === 0){

          let tempArray = [...this.state.topics];
          tempArray[index].enable_sync = payload.enable_sync;
          if (tempArray[index].some_sync) {
            tempArray[index].some_sync = !tempArray[index].some_sync
          }
          this.setState({
            topics:tempArray,
            loading: false
          });
        }
        this.getAllTopicSync(); 
      })
      .catch(error => {
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to edit topic',
            5000
          );
        }
        this.setState({
          loading: false
        });
      });
  }

  onDisableSync = (index)=>{
    this.setState({loading:true});
    const payload = {
      topic_id:this.state.topics[index].topic_id,
      subject_id: this.state.topics[index].subject_id,
      enable_sync:false
    };

    // LTI sync disable
    if( this.appProperties.enableLTI ) {
      this.setState({
        loading: false
      });
      return
    }
    
    ApiRequestService({
      method: 'post',
      url: '/sync/enableSyncTopic',
      data: payload
    })
      .then(res => {
        if (res.data.message !== null && res.data.message !== '') {
          NotificationManager.error(res.data.message, 'ERROR', 3000);
          this.setState({
            loading: false
          });
        }
        
        
        if(res.data && res.data.status === 0){

          let tempArray = [...this.state.topics];
          tempArray[index].enable_sync = payload.enable_sync;
          if (tempArray[index].some_sync) {
            tempArray[index].some_sync = !tempArray[index].some_sync
          }
          this.setState({
            topics:tempArray,
            loading: false
          });

        }

        
      })
      .catch(error => {
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to edit topic',
            5000
          );
        }
        this.setState({
          loading: false
        });
      });
  }
  editTopic(id) {
    this.setState({
      temp_topic: this.state.topics[id],
      temp_id: id,
      addMode: false
    });

    this.show(false);
  }
  updateTopicResponseHandler(res) {
    this.setState({
      loading: true
    });
    console.debug(res);
    let tempTopics = this.state.topics;
    tempTopics[this.state.temp_id] = this.state.temp_topic;
    this.setState({
      topics: tempTopics,
      temp_topic: topic,
      loading: false
    });
    this.hide();
  }

  updateTopic() {
    this.setState({ loading: true });
    var sub_id = parseInt(this.state.subject_id, 10);

    console.debug('Editing topic id:' + this.state.temp_topic.topic_id);
    console.debug('Editing topic name:' + this.state.temp_topic.topic_name);
    console.debug('Editing subject id:' + sub_id);

    const payload = {
      topic_name: this.state.temp_topic.topic_name,
      subject_id: sub_id,
      topic_id: this.state.temp_topic.topic_id,
      loading: false
    };

    ApiRequestService({
      method: 'post',
      url: '/updateTopic',
      data: payload
    }).then(this.updateTopicResponseHandler);
  }
  deleteTopic(id) {
    this.setState({ loading: true });
    console.debug(
      'Deleting topic i:' + id + ' id: ' + this.state.topics[id].topic_id
    );
    var sub_id = parseInt(this.state.subject_id, 10);
    const payload = {
      subject_id: sub_id,
      topic_id: this.state.topics[id].topic_id,
      archive_mode:this.state.archive_mode
    };
    ApiRequestService({
      method: 'post',
      url: '/deleteTopic',
      data: payload
    })
      .then(res => {
        console.debug('delete topic response', res);
        this.state.topics.splice(id, 1);
        this.state.countOfTCSQ.splice(id, 1);
        this.setState({
          countOfTCSQ:this.state.countOfTCSQ,
          topics: this.state.topics,
          loading: false
        });
        console.debug('Spliced Array', this.state.topics);
      })
      .catch(error => {
        //bug-tracker#162

        console.error('Error When Deleting ', error);
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to delete topic',
            5000
          );
        }
        this.setState({
          loading: false
        });
      });
  }

  changeTopicName(e) {
    let curTopic = this.state.temp_topic;
    curTopic.topic_name = e;
    this.setState({
      temp_topic: curTopic
    });
  }

  show = isTopicEnable => {
    //this.errorMessageHide();
    if (isTopicEnable) {
      this.setState({
        temp_topic: {
          topic_name: '',
          topic_id: ''
        }
      });
    }

    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({
      visible: false,
      addMode: true
    });
  };

  subjPage() {
    browserHistory.push(this.baseFolder + 'subjects');
  }

  //  errorMessageHide(){
  //     console.debug("errorType");
  //     var tempErrortype = "";
  //     var tempErrorMessage = "";
  //     this.setState({
  //         errorMessage: tempErrortype,
  //         errorType:tempErrortype,
  //     })

  // }

  delete = id => {
    confirmAlert({
      title: 'Are you sure want to delete this Topic ?',
      message: 'Press Confirm to submit',

      cancelLabel: 'Confirm',
      confirmLabel: 'Cancel',
      onCancel: () => this.deleteTopic(id)
      //   onCancel: () => dissmiss,
    });
  };

  isEnterPressed(event){
    var code = event.keyCode || event.which;
    console.debug("evet , code ,",event,code);
    if(code === 13) { //13 is the enter keycode
      if (this.state.addMode) {
        this.addTopic();
      }else{
        this.updateTopic();
      }
    }
  }

  render() {
    let button = null;
    if (this.state.addMode) {
      button = (
        <button style={styles.addButton} onClick={this.addTopic}>
          Add Topic
        </button>
      );
    } else {
      button = (
        <Button style={styles.addButton} onClick={this.updateTopic}>
          Update Topic
        </Button>
      );
    }
    var cancelButton = (
      <Button style={styles.cancelButton} onClick={this.hide}>
        Cancel
      </Button>
    );

    const actions = [];
    actions.push(button);
    actions.push(cancelButton);

    var tbody = null;
    if (this.state.topics != null) {
      tbody = (
        <tbody className="subjectTableBodyClass">
          {this.state.topics.map((topic, i) => {
             if (topic.sync_validation || this.state.AllTopForSuperadmin) {
              return(

                <TableRow
                  key={i}
                  data={topic}
                  pushId={'topics'}
                  id={topic.topic_id}
                  name={topic.topic_name}
                  title={'Topics'}
                  type={''}
                  url={
                    'category?topic_id=' +
                    topic.topic_id +
                    '&subject_id=' +
                    this.state.subject_id +
                    '&subject_name=' +
                    this.state.subject_name +
                    '&topic_name=' +
                    topic.topic_name+
                    '&archive_mode='+
                    this.state.archive_mode+
                    '&archive_id='+
                    this.state.archive_id
                  }
                  onEditClick={() => this.editTopic(i)}
                  onDeleteClick={() => this.delete(i)}
                  show_archive_actions={this.state.archive_mode}
                  instructorSubject={(this.state.instSubjects && this.state.instSubjects[topic.subject_id] === true) }
                  onArchiveRestoreClick={()=>this.onArchiveRestoreClick(topic)}
                  countOfTCSQ={this.state.countOfTCSQ !== undefined && this.state.countOfTCSQ !== null ? this.state.countOfTCSQ[i] : null}
                  syncEnabled={topic.enable_sync}
                  rowIndex={i}
                  onHandleRedirect={()=> this.onHandleRedirect(topic)}
                  synloading={this.state.synloading}
                  onEnableSync={() => this.onEnableSync(i)}
                  onDisableSync={()=> this.onDisableSync(i)}
                  someSyncEnabled={topic.some_sync}
                  syncSwitch={this.state.syncAccess}
                />
              )
             }
            })}
        </tbody>
      );
    }
    
    return (
      (this.state.loading) ?
      <div>

          {
             this.state.redirectLoading ? <p style={{ 
              display: "flex" ,justifyContent: "center",
              color:"#bb0000",fontSize:"20px",fontWeight:"500"
              }}>
                Redirecting to Source University, Please wait...</p> : " "
          }

        ( <div   style={{ marginTop:"-261px"}}  >
            <LoadingSpinner loading={this.state.loading} />
          </div>)
      </div>
      :
     (  
       <div className="subjectDivContainer" style={{ marginTop:"120px"}}>
        {/* <div onClick = {this.subjPage} style={subjPage}>Subjects >  </div>
            <div onClick = {this.topicPage} style={topicPage}>Topics</div> */}

        <div style={styles.topicTitle} className="subjectDivClass">
          Subject Details - {this.state.subject_name}
          {
            this.state.readOnly || (this.appProperties.enableLTI)
            ?
            null
            :
            <div style={styles.syncvalidationSwitch}>
                {
                      this.state.syncAccess ? 
                      <div>
                        
                      <SelectionControl 
                      id={"syncsubhideswitch"}
                      type="switch"
                      name="syncHide"
                      label={null}
                      checked={this.state.AllCatForSuperadmin}
                      onChange={() => this.superAdminSyncTopValidation()}
                      style={{float: 'none', display: 'inline-block',top:"-8px",position:"relative"}}
                      data-tip data-for='test-mode-sync'
                      />
                      <ReactTooltip id={'test-mode-sync'} type='light' className='tool-tip'>
                        <span>{'View As super Admin to show all topic'}</span>
                      </ReactTooltip> 
                      </div>
                      : ""
                    }
              <div  style={this.state.currSubject ?  styles.floatRight : {display:"none"} }>
                <Button className="archive-button" primary raised
                    style={{float: "right"}}
                      onClick={() => this.show(true)}>
                        Add a New Topic
                  </Button>
              </div>
            
            </div>
          }
          
        </div>

        <DialogContainer
          id="simple-action-dialog"
          visible={this.state.visible}
          onHide={this.hide}
          actions={actions}
         // title="New Topic"
          width="500px"
        >
        <p style={{fontSize:"medium"}}><b><label for="topId">New Topic</label></b></p>
          <TextField
            id="topId"
            name="topic_name"
            defaultValue={this.state.temp_topic.topic_name || ''}
            onChange={this.changeTopicName}
            style={topicStyles.dialogText}
            onKeyPress={this.isEnterPressed.bind(this)}              
          />
        </DialogContainer>
        <table style={styles.topicTable} className="subjectTableClass">
          <thead style={styles.thead} className="subjectTableHeadClass">
            <tr>
              <th>ID</th>
              <th style={{textAlign:'left',paddingLeft:'25px'}}>Topics</th>
              {/* <th colSpan="4">Total Number Of </th> */}
              <th>Categories</th>
              <th>SubCategories</th>
              <th>Questions</th>
              <th>Explanations</th>
                {
                   !this.appProperties.enableLTI ? 
                   <th>Actions</th> : ''
                }
            </tr>
            {/* <tr>
              <th></th>
              <th></th>
              <th>Categories</th>
              <th>SubCategories</th>
              <th>Questions</th>
              <th>Explanations</th>
              <th></th>
            </tr> */}
          </thead>

          {tbody}
        </table>
        <center>
          {
            !this.appProperties.enableLTI ?  
           <div style={this.state.currSubject  ? {display:"none"}:{width:"35%"}}className='image-resize-warning'>
             <p><b>Note :</b> Contact Administrator to gain access to edit this page.</p>
            </div> : " "
          }
        
        {
          this.appProperties.enableLTI  ? 
          <div style={{width:"35%",marginTop:"10px"}} className='image-resize-warning'>
          <p><b>Note :</b> No one can make any changes in the LTI version. Please go to the OSU core question bank to make changes</p>
          </div> : " "
        }
        </center>
      </div>
     )
    );
  }

  //Archive Restore
  onArchiveRestoreClick = (topic) => {
    let payload = {
      subject_id:topic.subject_id,
      topic_id:topic.topic_id
    };
    restoreQuestionBankHandler(payload);
  }
}
